import React from 'react'

function PhoneIcon() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M4.65354 6.34637C3.56565 5.25807 2.52515 3.99665 3.02335 3.49716C3.73649 2.78485 4.35815 2.3449 3.0939 0.771436C1.82965 -0.802027 0.991956 0.406464 0.297555 1.10223C-0.500455 1.89502 0.254568 4.86884 3.1964 7.80847C6.13824 10.7481 9.10322 11.5001 9.90123 10.7018C10.5923 10.0104 11.8004 9.17133 10.2319 7.9077C8.66343 6.64408 8.21924 7.26376 7.5061 7.97827C7.00348 8.47556 5.74254 7.43467 4.65354 6.34637Z"
          fill="#010101"
        />
      </g>
    </svg>
  )
}

export default PhoneIcon
